import Vue               from 'vue'
import Vuex              from 'vuex'
import microsoftAuth     from './modules/microsoftAuth.store'
import signaturesApiAuth from './modules/signaturesApiAuth.store'


Vue.use( Vuex )

export default new Vuex.Store( {
	getters:   {
		isSignedIn: function( state ) {
			if( !state.microsoftAuth.isSignedIn || !state.microsoftAuth.fresh || !state.signaturesApiAuth.isSignedIn || !state.signaturesApiAuth.fresh ) {
				return false;
			}
			return true;
		},

		snackbars:function(state) {
			return state.snackbars;
		},

		snackbarTimeout:function(state) {
			if(typeof(state.snackbars[0])!='undefined' && typeof(state.snackbars[0].timeout)=='number') {
				return state.snackbars[0].timeout;
			}
			return 4000;
		},
	},
	state:     {
		snackbars:[],
		showAdvanced:false
	},
	mutations: {

		addSnackbar:function( state, snackbar ) {
			state.snackbars.push( snackbar );
		},

		removeSnackbar:function(state, id ) {
			let index = state.snackbars.findIndex(item => item.id === id);
			if (index !== -1) {
				state.snackbars.splice(index, 1);
			}
		},

		setShowAdvanced:function(state, value) {
			state.showAdvanced = value;
		}

	},
	actions:   {
		initialize: async function ({commit}) {
			if ( localStorage.getItem( 'store.showAdvanced' ) ) {
				// Replace the state object with the stored item
				let data = localStorage.getItem( 'store.showAdvanced' );
				if(data==='true' || data===false || data===true || data===false) {
					commit('setShowAdvanced', data);
				}
			}
		},

		flushStoreCache:async function() {
			localStorage.removeItem('store.microsoftAuth')
			localStorage.removeItem('store.signaturesApiAuth')
		},
		signOut: async function( {dispatch}) {
			await dispatch('flushStoreCache');
			await dispatch('microsoftAuth/signOut')
		},


		sendSnackbar:function({commit}, payload ) {
			let snackbar = {
				id: "snackbar_"+Math.random().toString(36)	.substr(2, 9),
				color: payload.color,
				message: payload.message,
			};

			if('timeout' in payload) {
				snackbar.timeout =  payload.timeout;
			}

			commit('addSnackbar', snackbar);

		},

		sendErrorSnackbar:function({commit}, e ) {
			let message = '';
			if(e.code!==0) {
				message += e.code+': ';
			}
			message += e.message;

			let snackbar = {
				id: "snackbar_"+Math.random().toString(36)	.substr(2, 9),
				color: 'error',
				message: message,
				timeout:5000
			};

			commit('addSnackbar', snackbar);

		},

		removeSnackbar({commit} ,id ) {
			commit('removeSnackbar', id);
		},

		setShowAdvanced({commit}, value) {
			commit('setShowAdvanced', value);
		}
	},
	modules:   {
		microsoftAuth:     microsoftAuth,
		signaturesApiAuth: signaturesApiAuth
	}
} )
